import { axiosConfigBuilder } from "@shared/utils/configs/axiosConfigBuilder";

export const axiosInstance = axiosConfigBuilder().setBaseUrl().build();

export const axiosStaticInstance = axiosConfigBuilder().build();
